"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = __importDefault(require("qs"));
const lodash_1 = __importDefault(require("lodash"));
const API = {
    getServiceBillingStatus: `/api/console/billing/info/status`,
    getBillingCompanyInfo: `/api/console/billing/info/company`,
    getLatestBillingInvoice: `/api/console/billing/info/invoice/latest`,
};
class ServiceBilling {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getServiceBillingStatus(clientId) {
        const data = {
            result: null,
            entities: {},
        };
        const url = `${API.getServiceBillingStatus}?${qs_1.default.stringify({ clientId })}`;
        const res = await this._httpClient.get(url);
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getBillingCompanyInfo(clientId) {
        const data = {
            result: null,
            entities: {},
        };
        const url = `${API.getBillingCompanyInfo}?${qs_1.default.stringify({
            clientId,
        })}`;
        const res = await this._httpClient.get(url);
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getLatestBillingInvoice(clientId) {
        const data = {
            result: null,
            entities: {},
        };
        const url = `${API.getLatestBillingInvoice}?${qs_1.default.stringify({
            clientId,
        })}`;
        const res = await this._httpClient.get(url);
        if (!res.data || !res.data.data || lodash_1.default.isEmpty(res.data.data)) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
}
exports.default = ServiceBilling;
